// ConsentSection.jsx
import { useState } from "react";
import styles from "./ConsentSection.module.css";

const ConsentSection = ({ onNext }) => {
    const [accepted, setAccepted] = useState(false);

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <div className={styles.header}>
                    <h2 className={styles.title}>Section A: Study Consent</h2>
                    <p className={styles.description}>
                        Study Number: Demo/2024/26 | Version: 1.0
                    </p>
                </div>

                <div className={styles.content}>
                    <div className={styles.infoBox}>
                        <div className={styles.section}>
                            <h3 className={styles.sectionTitle}>Study Title</h3>
                            <p className={styles.sectionText}>
                                A questionnaire based study to Assess knowledge, attitude, and practice pattern
                                of healthcare physicians in India towards management of Hypertension with
                                sympathetic over activity - cross-sectional study
                            </p>
                        </div>

                        <div className={styles.section}>
                            <h4 className={styles.subheading}>Purpose</h4>
                            <p className={styles.subtext}>
                                This study aims to understand current practices and perspectives of healthcare
                                professionals regarding hypertension management, particularly in cases involving
                                sympathetic overactivity.
                            </p>
                        </div>

                        <div className={styles.section}>
                            <h4 className={styles.subheading}>Voluntary Participation</h4>
                            <p className={styles.subtext}>
                                Your participation is completely voluntary. All responses will be kept confidential
                                and used solely for research purposes. The survey will take approximately 15-20 minutes
                                to complete.
                            </p>
                        </div>
                    </div>

                    {/* <div className={styles.checkboxWrapper}>
                        <input
                            type="checkbox"
                            id="consent"
                            checked={accepted}
                            onChange={(e) => setAccepted(e.target.checked)}
                            className={styles.checkbox}
                        />
                        <label htmlFor="consent" className={styles.checkboxLabel}>
                            I have read and understood the study information. I voluntarily agree to participate
                            in this research study and understand that I can withdraw at any time.
                        </label>
                    </div> */}

                    <div className={styles.buttonWrapper}>
                        <button
                            onClick={onNext}
                            // disabled={!accepted}
                            className={styles.continueButton}
                        >
                            I Agree
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConsentSection;